/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, Box, Button, Checkbox, CircularProgress, Divider, FormControl, FormControlLabel, FormGroup, Grid, IconButton, InputLabel, OutlinedInput, styled, TextField, Tooltip, Typography } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import { showNotification } from "../../../common/Notification/ToastifyNotification";
import { apiRequest } from "../../../common/common";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { ActionStage, ArchitecturalCode, FundingSource, ItemStatus, PAStatus, PriceType, ProductType, ReportType, Responsibility } from "../../../common/const";
import moment from "moment";
import { ClearIcon } from "@mui/x-date-pickers";
import { LoadingPage } from "../../../common/LoadingPage";
import { useSelector } from "react-redux";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;


const CustomFilterPanelWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  padding: 10,
});

// The content area where filter controls will go
const FilterContent = styled(Box)({
  flexGrow: 1,         // Take up available space
  overflowY: 'auto',   // Enable scrolling if content overflows
  paddingBottom: 30,   // Ensure space for the fixed footer
});

// Footer area with fixed button
const FilterFooter = styled(Box)({
  position: 'sticky',
  bottom: 0,
  display: 'flex',
  gap: 5
});

// Fixed button in the footer
const FixedButton = styled(Button)({
  width: '100%',
});

const DemoBox1 = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  paddingTop: 60
}));

export default function FilterPanel({
  projectId,
  reportType,
  applyFilter
}) {
  const { user } = useSelector((state) => state.users);
  const [expanded, setExpanded] = useState(false);
  const [filters, setFilters] = useState([]);
  const [vendorLoading, setVendorLoading] = useState(false);
  const [vendorData, setVendorData] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [manufacturerData, setManufacturerData] = useState([]);
  const [manufacturerLoading, setManufacturerLoading] = useState(false);
  const [manInputValue, setManInputValue] = useState('');
  const [categoryData, setCategoryData] = useState([]);
  const [categoryLoading, setCategoryLoading] = useState(false);
  const [subCategoryData, setSubCategoryData] = useState([]);
  const [subCategoryLoading, setSubCategoryLoading] = useState(false);
  const [categoryInput, setCategoryInput] = useState('');
  const [subCategoryInput, setSubCategoryInput] = useState('');
  const [budgetLoading, setBudgetLoading] = useState(false);
  const [budgetData, setBudgetData] = useState([]);
  const [buildingData, setBuildingData] = useState([]);
  const [depData, setDepData] = useState([]);
  const [levelData, setLevelData] = useState([]);
  const [roomData, setRoomData] = useState([]);
  const [actionData, setActionData] = useState([]);
  const [requisitionData, setRequisitionData] = useState([]);
  const [biddingData, setBiddingData] = useState([]);
  const [rfqData, setRFQData] = useState([]);
  const [poData, setPOData] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);
  const [bidGroupData, setBidGroupData] = useState([]);
  const [bidGroupLoading, setBidLoading] = useState(false);
  const isProcurementReport = [ReportType[30], ReportType[31], ReportType[32], ReportType[33], ReportType[34], ReportType[35], ReportType[36], ReportType[37], ReportType[38]].includes(reportType);

  const getRooms = async () => {
    const url = [
      `/project-room?projectId=${projectId}`,
      filters.find((a) => a.field === 'department_id')?.values.length > 0 ? `&departmentIds=${filters.find((a) => a.field === 'department_id')?.values.toString()}` : '',
      `pageNo=1`,
      `pageSize=100`,
    ].filter(Boolean).join('&');
    try {
      const response = await apiRequest('get', `${url}`);
      const { data } = response.data;
      setRoomData(data);
      setDataLoading(false);
    } catch (error) {
      setDataLoading(false);
      showNotification(error?.response?.data.error || error.message, 'error');
    }
  }

  const getLevel = async () => {
    const url = [
      `/level?projectId=${projectId}`,
      filters.find((a) => a.field === 'building_id')?.values.length > 0 ? `&buildingId=${filters.find((a) => a.field === 'building_id')?.values?.toString()}` : '',
      `pageNo=1`,
      `pageSize=100`,
    ].filter(Boolean).join('&');
    try {
      const response = await apiRequest('get', `${url}`);
      const { data } = response.data;
      setLevelData(data);
      setDataLoading(false);
    } catch (error) {
      setDataLoading(false);
      showNotification(error?.response?.data.error || error.message, 'error');
    }
  }

  const getDepartment = async () => {
    const url = [
      `/department?projectId=${projectId}`,
      filters.find((a) => a.field === 'level_id')?.values.length > 0 ? `&levelId=${filters.find((a) => a.field === 'level_id')?.values?.toString()}` : '',
      `pageNo=1`,
      `pageSize=100`,
    ].filter(Boolean).join('&');
    try {
      const response = await apiRequest('get', `${url}`);
      const { data } = response.data;
      setDepData(data);
      setDataLoading(false);
    } catch (error) {
      setDataLoading(false);
      showNotification(error?.response?.data.error || error.message, 'error');
    }
  }

  const getBuilding = async () => {
    const url = [
      `/building?projectId=${projectId}`,
      `pageNo=1`,
      `pageSize=100`,
    ].filter(Boolean).join('&');
    try {
      const response = await apiRequest('get', `${url}`);
      const { data } = response.data;
      setBuildingData(data);
      setDataLoading(false);
    } catch (error) {
      setDataLoading(false);
      showNotification(error?.response?.data.error || error.message, 'error');
    }
  }

  useEffect(() => {
    if (filters.length > 0) {
      if (filters.find((a) => a.field === 'department_id') && !isProcurementReport) {
        getRooms();
      }
      if (filters.find((a) => a.field === 'building_id') && !isProcurementReport) {
        getLevel();
      }
      if (filters.find((a) => a.field === 'level_id') && !isProcurementReport) {
        getDepartment();
      }
    }
  }, [filters, isProcurementReport]);

  useEffect(() => {
    if (isProcurementReport) {
      if (reportType !== ReportType[30]) {
        getActionData([ReportType[31], ReportType[35]].includes(reportType) ? "requisition" : [ReportType[32], ReportType[36]].includes(reportType) ? 'bidding' : [ReportType[33], ReportType[37]].includes(reportType) ? 'rfq' : 'purchase_order');
      } else {
        getProcurementActionData('requisition');
        getProcurementActionData('bidding');
        getProcurementActionData('rfq');
        getProcurementActionData('purchase_order');
      }
    } else if(reportType === ReportType[40]) {
      getActionData('purchase_order');
    }
  }, [reportType ,isProcurementReport]);

  const getSubCategoryData = async (searchText) => {
    try {
      setSubCategoryLoading(true);
      const response = await apiRequest('get', `/project-item/filter-values/${projectId}?type=sub_category${searchText ? `&searchText=${searchText}` : ''}`);
      const { data } = response.data;
      if (data?.length > 0) {
        setSubCategoryData(data);
        setSubCategoryLoading(false);
      } else {
        setSubCategoryData([]);
        setSubCategoryLoading(false);
      }
    } catch (error) {
      setSubCategoryLoading(false);
      showNotification(error?.response?.data.error || error.message, 'error');
    }
  }

  const getCategoryData = async (searchText) => {
    try {
      setCategoryLoading(true);
      const response = await apiRequest('get', `/project-item/filter-values/${projectId}?type=category${searchText ? `&searchText=${searchText}` : ''}`);
      const { data } = response.data;
      if (data?.length > 0) {
        setCategoryData(data);
        setCategoryLoading(false);
      } else {
        setCategoryData([]);
        setCategoryLoading(false);
      }
    } catch (error) {
      setCategoryLoading(false);
      showNotification(error?.response?.data.error || error.message, 'error');
    }
  }

  const getVendorData = async (searchText) => {
    try {
      setVendorLoading(true);
      const response = await apiRequest('get', `/project-item/filter-values/${projectId}?type=vendor${searchText ? `&searchText=${searchText}` : ''}`);
      const { data } = response.data;
      if (data?.length > 0) {
        if (isProcurementReport) {
          data.unshift({
            product_provider_id: '',
            name: 'Unspecified'
          })
        }
        setVendorData(data);
        setVendorLoading(false);
      } else {
        setVendorData([]);
        setVendorLoading(false);
      }
    } catch (error) {
      setVendorLoading(false);
      showNotification(error?.response?.data.error || error.message, 'error');
    }
  }

  const getManufacturerData = async (searchText) => {
    try {
      setManufacturerLoading(true);
      const response = await apiRequest('get', `/project-item/filter-values/${projectId}?type=manufacturer${searchText ? `&searchText=${searchText}` : ''}`);
      const { data } = response.data;
      if (data?.length > 0) {
        if (isProcurementReport) {
          data.unshift({
            product_provider_id: '',
            name: 'Unspecified'
          })
        }
        setManufacturerData(data);
        setManufacturerLoading(false);
      } else {
        setManufacturerData([]);
        setManufacturerLoading(false);
      }
    } catch (error) {
      setManufacturerLoading(false);
      showNotification(error?.response?.data.error || error.message, 'error');
    }
  }

  const getBudgetData = async () => {
    try {
      setBudgetLoading(true);
      const response = await apiRequest('get', `/budget?projectId=${projectId}&pageNo=1&pageSize=100`);
      const { data } = response.data;
      if (data?.length > 0) {
        setBudgetData(data);
      }
      setBudgetLoading(false);
    } catch (error) {
      setBudgetLoading(false);
      showNotification(error?.response?.data.error || error.message, 'error');
    }
  }

  const getActionData = async (type) => {
    try {
      setBudgetLoading(true);
      const response = await apiRequest('get', `/purchase-module?pageNo=1&pageSize=100&projectId=${projectId}&type=${type}`);
      const { data } = response.data;
      if (data?.length > 0) {
        setActionData(data);
      }
      setBudgetLoading(false);
    } catch (error) {
      setBudgetLoading(false);
      showNotification(error?.response?.data.error || error.message, 'error');
    }
  }

  const getProcurementActionData = async (type) => {
    try {
      setBudgetLoading(true);
      const response = await apiRequest('get', `/purchase-module?pageNo=1&pageSize=100&projectId=${projectId}&type=${type}`);
      const { data } = response.data;
      if (data?.length > 0) {
        if (type === 'requisition') {
          setRequisitionData(data);
        } else if (type === 'bidding') {
          setBiddingData(data);
        } else if (type === 'rfq') {
          setRFQData(data)
        } else {
          setPOData(data)
        }
      }
      setBudgetLoading(false);
    } catch (error) {
      setBudgetLoading(false);
      showNotification(error?.response?.data.error || error.message, 'error');
    }
  }

  const getBidGroupData = async () => {
    try {
      setBidLoading(true);
      const response = await apiRequest('get', `/bid-group?organizationId=${user?.organization?.organization_id}`);
      const { data } = response.data;
      setBidGroupData(data);
      setBidLoading(false);
    } catch (error) {
      setBidLoading(false);
      showNotification(error?.response?.data.error || error.message, 'error');
    }
  }

  const handleChange = (panel) => (event, isExpanded) => {
    if (panel === 'panel2' && isExpanded) {
      getBudgetData();
    }
    if (panel === 'panel3' && isExpanded) {
      getBuilding();
    }
    if (panel === 'panel4' && isExpanded) {
      getCategoryData();
      getSubCategoryData();
    }
    if (panel === 'panel6' && isExpanded) {
      getDepartment();
    }
    if (panel === 'panel9' && isExpanded) {
      getLevel();
    }
    if (panel === 'panel10' && isExpanded) {
      getManufacturerData();
    }
    if (panel === 'panel16' && isExpanded) {
      getVendorData();
    }
    if (panel === 'panel21' && isExpanded) {
      getRooms();
    }
    if (panel === 'panel25' && isExpanded) {
      getBidGroupData();
    }
    setExpanded(isExpanded ? panel : false);
  };

  const handleFilter = async () => {
    if (filters.find((a) => a.field === 'architectural_code')?.values?.length === 0 && !isProcurementReport) {
      showNotification('Please select Architectural Code', 'error');
    } else if (filters.find((a) => a.field === 'features')?.values?.length === 0 && !isProcurementReport) {
      showNotification('Please select atleast one feature options', 'error');
    } else if (filters.find((a) => a.field === 'price_type')?.values?.length === 0 && !isProcurementReport) {
      showNotification('Please select Price Type', 'error');
    } else if (filters.find((a) => a.field === 'building_id')?.values?.length === 0 && !isProcurementReport) {
      showNotification('Please select value from Building', 'error');
    } else if (filters.find((a) => a.field === 'level_id')?.values?.length === 0 && !isProcurementReport) {
      showNotification('Please select value from Level', 'error');
    } else if (filters.find((a) => a.field === 'department_id')?.values?.length === 0 && !isProcurementReport) {
      showNotification('Please select value from Department', 'error');
    } else if (filters.find((a) => a.field === 'budget_id')?.values?.length === 0 && !isProcurementReport) {
      showNotification('Please select Budget', 'error');
    } else if (filters.find((a) => a.field === 'category')?.values?.length === 0 && filters.find((a) => a.field === 'sub_category')?.values?.length === 0 && !isProcurementReport) {
      showNotification('Please select category or subcategory', 'error');
    } else if (filters.find((a) => a.field === 'funding_source')?.values?.length === 0 && !isProcurementReport) {
      showNotification('Please select Funding Source', 'error');
    } else if (filters.find((a) => a.field === 'manufacturer_id')?.values?.length === 0) {
      showNotification('Please select manufacturer', 'error');
    } else if (filters.find((a) => a.field === 'furnish_responsibility')?.values?.length === 0 && !isProcurementReport) {
      showNotification('Please select Furnish Responsibility', 'error');
    } else if (filters.find((a) => a.field === 'install_responsibility')?.values?.length === 0 && !isProcurementReport) {
      showNotification('Please select Install Responsibility', 'error');
    } else if (filters.find((a) => a.field === 'stage')?.values?.length === 0 && !isProcurementReport) {
      showNotification('Please select Stage', 'error');
    } else if (filters.find((a) => a.field === 'status')?.values?.length === 0) {
      showNotification('Please select Status', 'error');
    } else if (filters.find((a) => a.field === 'type')?.values?.length === 0 && !isProcurementReport) {
      showNotification('Please select Type', 'error');
    } else if (filters.find((a) => a.field === 'vendor_id')?.values.length === 0) {
      showNotification('Please select vendor', 'error');
    } else if (filters.find((a) => a.field === 'action_id')?.values?.length === 0 && isProcurementReport) {
      showNotification(`Please select ${[ReportType[31], ReportType[35]].includes(reportType) ? "Requisition ID" : [ReportType[32], ReportType[36]].includes(reportType) ? 'Bid ID' : [ReportType[33], ReportType[37]].includes(reportType) ? 'RFQ ID' : 'PO ID'}`, 'error');
    } else if (filters.find((a) => a.field === 'pa_id')?.values?.length === 0 && isProcurementReport) {
      showNotification(`Please select PA ID`, 'error');
    } else if (filters.find((a) => a.field === 'requisition_no')?.values?.length === 0 && isProcurementReport) {
      showNotification(`Please select Requisition #`, 'error');
    } else if (filters.find((a) => a.field === 'bid_no')?.values?.length === 0 && isProcurementReport) {
      showNotification(`Please select Bid #`, 'error');
    } else if (filters.find((a) => a.field === 'rfq_no')?.values?.length === 0 && isProcurementReport) {
      showNotification(`Please select RFQ #`, 'error');
    } else if (filters.find((a) => a.field === 'po_no')?.values?.length === 0 && isProcurementReport) {
      showNotification(`Please select PO #`, 'error');
    }  else if (filters.find((a) => a.field === 'action_no')?.values?.length === 0 && isProcurementReport) {
      showNotification(`Please select ${[ReportType[31], ReportType[35]].includes(reportType) ? "Requisition No" : [ReportType[32], ReportType[36]].includes(reportType) ? 'Bid No' : [ReportType[33], ReportType[37]].includes(reportType) ? 'RFQ No' : 'PO No'}`, 'error');
    } else if (filters?.is_quote === null && isProcurementReport) {
      showNotification('Please select Quote Option', 'error');
    } else if (filters.find((a) => a.field === 'bid_group_id')?.values?.length === 0 && isProcurementReport) {
      showNotification('Please select Bid Group', 'error');
    } else if (Object.keys(filters).length === 0) {
      showNotification('Please select any field before apply filter', 'error');
    } else if (filters.find((a) => a.field === 'need_by_date')?.start === null || filters.find((a) => a.field === 'need_by_date')?.end === null) {
      showNotification('Please select Need By Date', 'error');
    } else if (filters.find((a) => a.field === 'list_price')?.start > filters.find((a) => a.field === 'list_price')?.end) {
      showNotification('The minimum value cannot be greater than or equal to the maximum value', 'error');
    } else {
      setExpanded(false);
      await applyFilter(filters);
    }
  }

  return (
    <CustomFilterPanelWrapper>
      {dataLoading && (<LoadingPage isLoading={dataLoading} />)}
      <DemoBox1>
        <Typography variant="body1" style={{ fontWeight: 'bold' }}>Filters</Typography>
        <IconButton onClick={() => {
          applyFilter([]);
          setFilters([]);
          setExpanded(false);
        }}>
          <ClearIcon />
        </IconButton>
      </DemoBox1>
      <Divider />
      <FilterContent>
        {!isProcurementReport && (
          <>
            <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                  <Box display="flex" alignItems="center">
                    {filters.find((a) => a.field === 'architectural_code')?.values?.length > 0 && (
                      <CheckIcon color="primary" />
                    )}
                    <Typography component="span">Architectural Code</Typography>
                  </Box>
                  {expanded === 'panel1' && (
                    <Tooltip title="Remove Filter">
                      <CloseIcon
                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                        onClick={() => {
                          setFilters(filters.filter((a) => a.field !== 'architectural_code'));
                          setExpanded(false);
                        }}
                        fontSize="20"
                      />
                    </Tooltip>
                  )}
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Autocomplete
                  value={ArchitecturalCode.filter((c) => filters.find((a) => a.field === 'architectural_code')?.values?.includes(c.value)) || []}
                  id="checkboxes-tags-demo"
                  size="small"
                  fullWidth
                  multiple
                  clearIcon={true}
                  disableCloseOnSelect
                  options={ArchitecturalCode}
                  getOptionLabel={(option) => option?.name}
                  renderOption={(props, option, { selected }) => {
                    const { key, ...optionProps } = props;
                    return (
                      <li key={key} {...optionProps}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option.name}
                      </li>
                    );
                  }}
                  onChange={(event, newValue) => {
                    const arr = [...filters];
                    const index = arr.findIndex((a) => a.field === 'architectural_code');

                    if (index !== -1) {
                      // Update the existing object
                      arr[index] = {
                        ...arr[index],
                        values: newValue.map((a) => a.value),
                      };
                    } else {
                      // Add new object if not found
                      arr.push({
                        field: 'architectural_code',
                        op: 'in',
                        values: newValue.map((a) => a.value),
                      });
                    }
                    setFilters(arr);
                  }}
                  renderInput={(params) =>
                    <TextField
                      fullWidth
                      {...params}
                      label="Architectural Code"
                      name="Architectural Code"
                      variant="outlined"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />}
                />
              </AccordionDetails>
            </Accordion>
            <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2-content"
                id="panel2-header"
              >
                <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                  <Box display="flex" alignItems="center">
                    {filters.find((a) => a.field === 'budget_id')?.values?.length > 0 && (
                      <CheckIcon color="primary" />
                    )}
                    <Typography component="span">Budget</Typography>
                  </Box>
                  {expanded === 'panel2' && (
                    <Tooltip title="Remove Filter">
                      <CloseIcon
                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                        onClick={() => {
                          setFilters(filters.filter((a) => a.field !== 'budget_id'));
                          setExpanded(false);
                        }}
                        fontSize="20"
                      />
                    </Tooltip>
                  )}
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Autocomplete
                  value={budgetData.filter((c) => filters.find((a) => a.field === 'budget_id')?.values?.includes(c.budget_id)) || []}
                  id="checkboxes-tags-demo"
                  size="small"
                  fullWidth
                  multiple
                  clearIcon={true}
                  disableCloseOnSelect
                  options={budgetData}
                  getOptionLabel={(option) => option?.budget_name}
                  renderOption={(props, option, { selected }) => {
                    const { key, ...optionProps } = props;
                    return (
                      <li key={key} {...optionProps}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option.budget_name}
                      </li>
                    );
                  }}
                  onChange={(event, newValue) => {
                    const arr = [...filters];
                    const index = arr.findIndex((a) => a.field === 'budget_id');

                    if (index !== -1) {
                      // Update the existing object
                      arr[index] = {
                        ...arr[index],
                        values: newValue.map((a) => a.budget_id),
                      };
                    } else {
                      // Add new object if not found
                      arr.push({
                        field: 'budget_id',
                        op: 'in',
                        values: newValue.map((a) => a.budget_id),
                      });
                    }
                    setFilters(arr);
                  }}
                  renderInput={(params) =>
                    <TextField
                      fullWidth
                      {...params}
                      label="Budget"
                      name="Budget"
                      variant="outlined"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {budgetLoading ? <CircularProgress color="primary" size={20} /> : null}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />}
                />
              </AccordionDetails>
            </Accordion>
            <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel3-content"
                id="panel3-header"
              >
                <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                  <Box display="flex" alignItems="center">
                    {filters.find((a) => a.field === 'building_id')?.values?.length > 0 && (
                      <CheckIcon color="primary" />
                    )}
                    <Typography component="span">Building</Typography>
                  </Box>
                  {expanded === 'panel3' && (
                    <Tooltip title="Remove Filter">
                      <CloseIcon
                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                        onClick={() => {
                          setFilters(filters.filter((a) => a.field !== 'building_id'));
                          setExpanded(false);
                        }}
                        fontSize="20"
                      />
                    </Tooltip>
                  )}
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Autocomplete
                  value={buildingData.filter((c) => filters.find((a) => a.field === 'building_id')?.values?.includes(c.building_id)) || []}
                  id="checkboxes-tags-demo"
                  size="small"
                  fullWidth
                  multiple
                  clearIcon={true}
                  disableCloseOnSelect
                  options={buildingData}
                  getOptionLabel={(option) => option?.building_name}
                  renderOption={(props, option, { selected }) => {
                    const { key, ...optionProps } = props;
                    return (
                      <li key={key} {...optionProps}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option.building_name}
                      </li>
                    );
                  }}
                  onChange={(event, newValue) => {
                    const arr = [...filters];
                    const index = arr.findIndex((a) => a.field === 'building_id');

                    if (index !== -1) {
                      // Update the existing object
                      arr[index] = {
                        ...arr[index],
                        values: newValue.map((a) => a.building_id),
                      };
                    } else {
                      // Add new object if not found
                      arr.push({
                        field: 'building_id',
                        op: 'in',
                        values: newValue.map((a) => a.building_id),
                      });
                    }
                    setFilters(arr);
                  }}
                  renderInput={(params) =>
                    <TextField
                      fullWidth
                      {...params}
                      label="Building"
                      name="Building"
                      variant="outlined"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />}
                />
              </AccordionDetails>
            </Accordion>
            <Accordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel4-content"
                id="panel4-header"
              >
                <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                  <Box display="flex" alignItems="center">
                    {(filters.find((a) => a.field === 'category')?.values?.length > 0 || filters.find((a) => a.field === 'sub_category')?.values?.length > 0) && (
                      <CheckIcon color="primary" />
                    )}
                    <Typography component="span">Category</Typography>
                  </Box>
                  {expanded === 'panel4' && (
                    <Tooltip title="Remove Filter">
                      <CloseIcon
                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                        onClick={() => {
                          setFilters(filters.filter((a) => a.field !== 'category' && a.field !== 'sub_category'));
                          setExpanded(false);
                        }}
                        fontSize="20"
                      />
                    </Tooltip>
                  )}
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Autocomplete
                  value={categoryData.filter((c) => filters.find((a) => a.field === 'category')?.values?.includes(c?.category_id)) || []}
                  id="checkboxes-tags-demo"
                  size="small"
                  fullWidth
                  multiple
                  clearIcon={true}
                  disableCloseOnSelect
                  options={categoryData}
                  getOptionLabel={(option) => option?.name}
                  renderOption={(props, option, { selected }) => {
                    const { key, ...optionProps } = props;
                    return (
                      <li key={key} {...optionProps}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option.name}
                      </li>
                    );
                  }}
                  onChange={(event, newValue) => {
                    const arr = [...filters];
                    const index = arr.findIndex((a) => a.field === 'category');

                    if (index !== -1) {
                      // Update the existing object
                      arr[index] = {
                        ...arr[index],
                        values: newValue.map((a) => a.category_id),
                      };
                    } else {
                      // Add new object if not found
                      arr.push({
                        field: 'category',
                        op: 'in',
                        values: newValue.map((a) => a.category_id),
                      });
                    }
                    setFilters(arr);
                  }}
                  inputValue={categoryInput === 0 || categoryInput === 'on' ? '' : categoryInput}
                  onInputChange={(e) => {
                    if (e) {
                      setCategoryInput(e.target.value);
                      if (e?.target?.value?.length >= 1) {
                        getCategoryData(e?.target?.value);
                      }
                    }
                  }}
                  renderInput={(params) =>
                    <TextField
                      fullWidth
                      {...params}
                      label="Categories"
                      name="Categories"
                      variant="outlined"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {categoryLoading ? <CircularProgress color="primary" size={20} /> : null}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />}
                />
                <br />
                <Autocomplete
                  value={subCategoryData?.filter((c) => filters.find((a) => a.field === 'sub_category')?.values?.includes(c.category_id)) || []}
                  id="checkboxes-tags-demo"
                  size="small"
                  fullWidth
                  multiple
                  clearIcon={true}
                  disableCloseOnSelect
                  options={subCategoryData}
                  getOptionLabel={(option) => `${option?.name} (${option?.parent?.name})`}
                  inputValue={subCategoryInput === 0 || subCategoryInput === 'on' ? '' : subCategoryInput}
                  onInputChange={(e) => {
                    if (e) {
                      setSubCategoryInput(e.target.value);
                      if (e?.target?.value?.length >= 1) {
                        getCategoryData(e?.target?.value);
                      }
                    }
                  }}
                  renderOption={(props, option, { selected }) => {
                    const { key, ...optionProps } = props;
                    return (
                      <li key={key} {...optionProps}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {`${option?.name} (${option?.parent?.name})`}
                      </li>
                    );
                  }}
                  onChange={(event, newValue) => {
                    const arr = [...filters];
                    const index = arr.findIndex((a) => a.field === 'sub_category');

                    if (index !== -1) {
                      // Update the existing object
                      arr[index] = {
                        ...arr[index],
                        values: newValue.map((a) => a.category_id),
                      };
                    } else {
                      // Add new object if not found
                      arr.push({
                        field: 'sub_category',
                        op: 'in',
                        values: newValue.map((a) => a.category_id),
                      });
                    }
                    setFilters(arr);
                  }}
                  renderInput={(params) =>
                    <TextField
                      fullWidth
                      {...params}
                      label="Subcategories"
                      name="Subcategories"
                      variant="outlined"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {subCategoryLoading ? <CircularProgress color="primary" size={20} /> : null}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />}
                />
              </AccordionDetails>
            </Accordion>
            <Accordion expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel5-content"
                id="panel5-header"
              >
                <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                  <Box display="flex" alignItems="center">
                    {(filters.find((a) => a.field === 'list_price')?.start && filters.find((a) => a.field === 'list_price')?.end) && (
                      <CheckIcon color="primary" />
                    )}
                    <Typography component="span">Cost</Typography>
                  </Box>
                  {expanded === 'panel5' && (
                    <Tooltip title="Remove Filter">
                      <CloseIcon
                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                        onClick={() => {
                          setFilters(filters.filter((a) => a.field !== 'list_price'));
                          setExpanded(false);
                        }}
                        fontSize="20"
                      />
                    </Tooltip>
                  )}
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <FormControl size="small" fullWidth variant="outlined">
                      <InputLabel htmlFor="standard-adornment-password">Min</InputLabel>
                      <OutlinedInput
                        label="Min"
                        id="standard-adornment-password"
                        type='number'
                        value={filters.find((a) => a.field === 'list_price')?.start || ''}
                        onChange={(e) => {
                          const priceFilter = filters.find((a) => a.field === 'list_price');
                          const endValue = priceFilter?.end;

                          if (endValue === undefined || e.target.value < endValue) {
                            const arr = [...filters];
                            const index = arr.findIndex((a) => a.field === 'list_price');

                            if (index !== -1) {
                              arr[index] = {
                                ...arr[index],
                                start: e.target.value,
                              };
                            } else {
                              arr.push({
                                field: 'list_price',
                                op: 'range',
                                start: e.target.value,
                              });
                            }

                            setFilters(arr);
                          } else {
                            showNotification('The minimum value cannot be greater than or equal to the maximum value.', 'error');
                          }
                        }}
                        onKeyDown={(event) => {
                          if (event.keyCode === 38 || event.keyCode === 40) {
                            event.preventDefault();
                          }
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <FormControl size="small" fullWidth variant="outlined">
                      <InputLabel htmlFor="standard-adornment-password">Max</InputLabel>
                      <OutlinedInput
                        label="Max"
                        id="standard-adornment-password"
                        type='number'
                        value={filters.find((a) => a.field === 'list_price')?.end || ''}
                        onChange={(e) => {
                          const priceFilter = filters.find((a) => a.field === 'list_price');
                          const startValue = priceFilter?.start;

                          if (startValue !== undefined && e.target.value <= startValue) {
                            showNotification('The maximum value cannot be less than or equal to the minimum value.', 'error');
                          }

                          const arr = [...filters];
                          const index = arr.findIndex((a) => a.field === 'list_price');

                          if (index !== -1) {
                            arr[index] = {
                              ...arr[index],
                              end: e.target.value,
                            };
                          } else {
                            arr.push({
                              field: 'list_price',
                              op: 'range',
                              end: e.target.value,
                            });
                          }

                          setFilters(arr);
                        }}
                        onKeyDown={(event) => {
                          if (event.keyCode === 38 || event.keyCode === 40) {
                            event.preventDefault();
                          }
                        }}
                      />
                    </FormControl>
                  </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>
            <Accordion expanded={expanded === 'panel6'} onChange={handleChange('panel6')}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel6-content"
                id="panel6-header"
              >
                <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                  <Box display="flex" alignItems="center">
                    {filters.find((a) => a.field === 'department_id')?.values?.length > 0 && (
                      <CheckIcon color="primary" />
                    )}
                    <Typography component="span">Department</Typography>
                  </Box>
                  {expanded === 'panel6' && (
                    <Tooltip title="Remove Filter">
                      <CloseIcon
                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                        onClick={() => {
                          setFilters(filters.filter((a) => a.field !== 'department_id'));
                          setExpanded(false);
                        }}
                        fontSize="20"
                      />
                    </Tooltip>
                  )}
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Autocomplete
                  value={depData.filter((c) => filters.find((a) => a.field === 'department_id')?.values?.includes(c.department_id)) || []}
                  id="checkboxes-tags-demo"
                  size="small"
                  fullWidth
                  multiple
                  clearIcon={true}
                  disableCloseOnSelect
                  options={depData}
                  getOptionLabel={(option) => option?.department_name}
                  renderOption={(props, option, { selected }) => {
                    const { key, ...optionProps } = props;
                    return (
                      <li key={key} {...optionProps}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option.department_name}
                      </li>
                    );
                  }}
                  onChange={(event, newValue) => {
                    const arr = [...filters];
                    const index = arr.findIndex((a) => a.field === 'department_id');

                    if (index !== -1) {
                      // Update the existing object
                      arr[index] = {
                        ...arr[index],
                        values: newValue.map((a) => a.department_id),
                      };
                    } else {
                      // Add new object if not found
                      arr.push({
                        field: 'department_id',
                        op: 'in',
                        values: newValue.map((a) => a.department_id),
                      });
                    }
                    setFilters(arr);
                  }}
                  renderInput={(params) =>
                    <TextField
                      fullWidth
                      {...params}
                      label="Department"
                      name="Department"
                      variant="outlined"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />}
                />
              </AccordionDetails>
            </Accordion>
            <Accordion expanded={expanded === 'panel7'} onChange={handleChange('panel7')}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel7-content"
                id="panel7-header"
              >
                <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                  <Box display="flex" alignItems="center">
                    {filters.find((a) => a.field === 'division')?.values?.length > 0 && (
                      <CheckIcon color="primary" />
                    )}
                    <Typography component="span">Division (Org)</Typography>
                  </Box>
                  {expanded === 'panel7' && (
                    <Tooltip title="Remove Filter">
                      <CloseIcon
                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                        onClick={() => {
                          setFilters(filters.filter((a) => a.field !== 'division'));
                          setExpanded(false);
                        }}
                        fontSize="20"
                      />
                    </Tooltip>
                  )}
                </Box>
              </AccordionSummary>
            </Accordion>
            <Accordion expanded={expanded === 'panel18'} onChange={handleChange('panel18')}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel18-content"
                id="panel18-header"
              >
                <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                  <Box display="flex" alignItems="center">
                    {filters.find((a) => a.field === 'features')?.values?.length > 0 && (
                      <CheckIcon color="primary" />
                    )}
                    <Typography component="span">Features</Typography>
                  </Box>
                  {expanded === 'panel18' && (
                    <Tooltip title="Remove Filter">
                      <CloseIcon
                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                        onClick={() => {
                          setFilters(filters.filter((a) => a.field !== 'features'));
                          setExpanded(false);
                        }}
                        fontSize="20"
                      />
                    </Tooltip>
                  )}
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={filters.find((a) => a.field === 'features')?.value?.includes('seismic')}
                        onClick={(e) => {
                          const arr = [...filters];
                          const index = arr.findIndex((a) => a.field === 'features');
                          if (e.target.checked) {
                            if (index !== -1) {
                              const values = new Set(arr[index].value);
                              values.add('seismic');
                              arr[index] = {
                                ...arr[index],
                                values: Array.from(values),
                              };
                            } else {
                              arr.push({
                                field: 'features',
                                op: 'in',
                                values: ['seismic'],
                              });
                            }
                          } else {
                            if (index !== -1) {
                              const values = arr[index].values.filter((val) => val !== 'seismic');
                              if (values.length > 0) {
                                arr[index] = {
                                  ...arr[index],
                                  values: values,
                                };
                              } else {
                                arr.splice(index, 1);
                              }
                            }
                          }
                          setFilters(arr);
                        }}
                      />}
                    label="Seismic"
                  />
                </FormGroup>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={filters.find((a) => a.field === 'features')?.values?.includes('da_complient')}
                        onClick={(e) => {
                          const arr = [...filters];
                          const index = arr.findIndex((a) => a.field === 'features');
                          if (e.target.checked) {
                            if (index !== -1) {
                              const values = new Set(arr[index].values);
                              values.add('da_complient');
                              arr[index] = {
                                ...arr[index],
                                values: Array.from(values),
                              };
                            } else {
                              arr.push({
                                field: 'features',
                                op: 'in',
                                values: ['da_complient'],
                              });
                            }
                          } else {
                            if (index !== -1) {
                              const values = arr[index].values.filter((val) => val !== 'da_complient');
                              if (values.length > 0) {
                                arr[index] = {
                                  ...arr[index],
                                  values: values,
                                };
                              } else {
                                arr.splice(index, 1);
                              }
                            }
                          }
                          setFilters(arr);
                        }}
                      />}
                    label="ADA"
                  />
                </FormGroup>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={filters.find((a) => a.field === 'features')?.values?.includes('antimicrobial')}
                        onClick={(e) => {
                          const arr = [...filters];
                          const index = arr.findIndex((a) => a.field === 'features');
                          if (e.target.checked) {
                            if (index !== -1) {
                              const values = new Set(arr[index].values);
                              values.add('antimicrobial');
                              arr[index] = {
                                ...arr[index],
                                values: Array.from(values),
                              };
                            } else {
                              arr.push({
                                field: 'features',
                                op: 'in',
                                values: ['antimicrobial'],
                              });
                            }
                          } else {
                            if (index !== -1) {
                              const values = arr[index].values.filter((val) => val !== 'antimicrobial');
                              if (values.length > 0) {
                                arr[index] = {
                                  ...arr[index],
                                  values: values,
                                };
                              } else {
                                arr.splice(index, 1);
                              }
                            }
                          }
                          setFilters(arr);
                        }
                        }
                      />}
                    label="Antimicrobial"
                  />
                </FormGroup>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={filters.find((a) => a.field === 'features')?.values?.includes('green')}
                        onClick={(e) => {
                          const arr = [...filters];
                          const index = arr.findIndex((a) => a.field === 'features');
                          if (e.target.checked) {
                            if (index !== -1) {
                              const values = new Set(arr[index].values);
                              values.add('green');
                              arr[index] = {
                                ...arr[index],
                                values: Array.from(values),
                              };
                            } else {
                              arr.push({
                                field: 'features',
                                op: 'in',
                                values: ['green'],
                              });
                            }
                          } else {
                            if (index !== -1) {
                              const values = arr[index].values.filter((val) => val !== 'green');
                              if (values.length > 0) {
                                arr[index] = {
                                  ...arr[index],
                                  values: values,
                                };
                              } else {
                                arr.splice(index, 1);
                              }
                            }
                          }
                          setFilters(arr);
                        }
                        }
                      />}
                    label="Green"
                  />
                </FormGroup>
              </AccordionDetails>
            </Accordion>
            <Accordion expanded={expanded === 'panel8'} onChange={handleChange('panel8')}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel8-content"
                id="panel8-header"
              >
                <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                  <Box display="flex" alignItems="center">
                    {filters.find((a) => a.field === 'funding_source')?.values?.length > 0 && (
                      <CheckIcon color="primary" />
                    )}
                    <Typography component="span">Funding Source</Typography>
                  </Box>
                  {expanded === 'panel8' && (
                    <Tooltip title="Remove Filter">
                      <CloseIcon
                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                        onClick={() => {
                          setFilters(filters.filter((a) => a.field !== 'funding_source'));
                          setExpanded(false);
                        }}
                        fontSize="20"
                      />
                    </Tooltip>
                  )}
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Autocomplete
                  value={FundingSource.filter((c) => filters.find((a) => a.field === 'funding_source')?.values?.includes(c.value)) || []}
                  id="checkboxes-tags-demo"
                  size="small"
                  fullWidth
                  multiple
                  clearIcon={true}
                  disableCloseOnSelect
                  options={FundingSource}
                  getOptionLabel={(option) => option?.name}
                  renderOption={(props, option, { selected }) => {
                    const { key, ...optionProps } = props;
                    return (
                      <li key={key} {...optionProps}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option.name}
                      </li>
                    );
                  }}
                  onChange={(event, newValue) => {
                    const arr = [...filters];
                    const index = arr.findIndex((a) => a.field === 'funding_source');

                    if (index !== -1) {
                      // Update the existing object
                      arr[index] = {
                        ...arr[index],
                        values: newValue.map((a) => a.value),
                      };
                    } else {
                      // Add new object if not found
                      arr.push({
                        field: 'funding_source',
                        op: 'in',
                        values: newValue.map((a) => a.value),
                      });
                    }
                    setFilters(arr);
                  }}
                  renderInput={(params) =>
                    <TextField
                      fullWidth
                      {...params}
                      label="Funding Source"
                      name="Funding Source"
                      variant="outlined"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />}
                />
              </AccordionDetails>
            </Accordion>
            <Accordion expanded={expanded === 'panel9'} onChange={handleChange('panel9')}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel9-content"
                id="panel9-header"
              >
                <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                  <Box display="flex" alignItems="center">
                    {filters.find((a) => a.field === 'level_id')?.values?.length > 0 && (
                      <CheckIcon color="primary" />
                    )}
                    <Typography component="span">Level</Typography>
                  </Box>
                  {expanded === 'panel9' && (
                    <Tooltip title="Remove Filter">
                      <CloseIcon
                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                        onClick={() => {
                          setFilters(filters.filter((a) => a.field !== 'level_id'));
                          setExpanded(false);
                        }}
                        fontSize="20"
                      />
                    </Tooltip>
                  )}
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Autocomplete
                  value={levelData.filter((c) => filters.find((a) => a.field === 'level_id')?.values?.includes(c.level_id)) || []}
                  id="checkboxes-tags-demo"
                  size="small"
                  fullWidth
                  multiple
                  clearIcon={true}
                  disableCloseOnSelect
                  options={levelData}
                  getOptionLabel={(option) => option?.level_name}
                  renderOption={(props, option, { selected }) => {
                    const { key, ...optionProps } = props;
                    return (
                      <li key={key} {...optionProps}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option.level_name}
                      </li>
                    );
                  }}
                  onChange={(event, newValue) => {
                    const arr = [...filters];
                    const index = arr.findIndex((a) => a.field === 'level_id');

                    if (index !== -1) {
                      // Update the existing object
                      arr[index] = {
                        ...arr[index],
                        values: newValue.map((a) => a.level_id),
                      };
                    } else {
                      // Add new object if not found
                      arr.push({
                        field: 'level_id',
                        op: 'in',
                        values: newValue.map((a) => a.level_id),
                      });
                    }
                    setFilters(arr);
                  }}
                  renderInput={(params) =>
                    <TextField
                      fullWidth
                      {...params}
                      label="Level"
                      name="Level"
                      variant="outlined"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />}
                />
              </AccordionDetails>
            </Accordion>
          </>)}
        {![ReportType[32], ReportType[36]].includes(reportType) && (
          <Accordion expanded={expanded === 'panel10'} onChange={handleChange('panel10')}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel10-content"
              id="panel10-header"
            >
              <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                <Box display="flex" alignItems="center">
                  {filters.find((a) => a.field === 'manufacturer_id')?.values?.length > 0 && (
                    <CheckIcon color="primary" />
                  )}
                  <Typography component="span">Manufacturers</Typography>
                </Box>
                {expanded === 'panel10' && (
                  <Tooltip title="Remove Filter">
                    <CloseIcon
                      style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                      onClick={() => {
                        setFilters(filters.filter((a) => a.field !== 'manufacturer_id'));
                        setExpanded(false);
                      }}
                      fontSize="20"
                    />
                  </Tooltip>
                )}
              </Box>
            </AccordionSummary>
            <AccordionDetails>
              <Autocomplete
                value={manufacturerData.filter((c) => filters.find((a) => a.field === 'manufacturer_id')?.values?.includes(c.product_provider_id)) || []}
                id="checkboxes-tags-demo"
                size="small"
                fullWidth
                multiple
                clearIcon={true}
                disableCloseOnSelect
                options={manufacturerData}
                getOptionLabel={(option) => option?.name}
                renderOption={(props, option, { selected }) => {
                  const { key, ...optionProps } = props;
                  return (
                    <li key={key} {...optionProps}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option.name}
                    </li>
                  );
                }}
                onChange={(event, newValue) => {
                  const arr = [...filters];
                  const index = arr.findIndex((a) => a.field === 'manufacturer_id');

                  if (index !== -1) {
                    // Update the existing object
                    arr[index] = {
                      ...arr[index],
                      values: newValue.map((a) => a.product_provider_id),
                    };
                  } else {
                    // Add new object if not found
                    arr.push({
                      field: 'manufacturer_id',
                      op: 'in',
                      values: newValue.map((a) => a.product_provider_id),
                    });
                  }
                  setFilters(arr);
                }}
                inputValue={manInputValue === 0 || manInputValue === 'on' ? '' : manInputValue}
                onInputChange={(e) => {
                  if (e) {
                    setManInputValue(e.target.value);
                    if (e?.target?.value?.length >= 1) {
                      getManufacturerData(e?.target?.value);
                    }
                  }
                }}
                renderInput={(params) =>
                  <TextField
                    fullWidth
                    {...params}
                    label="Manufacturer"
                    name="Manufacturer"
                    variant="outlined"
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {manufacturerLoading ? <CircularProgress color="primary" size={20} /> : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />}
              />
            </AccordionDetails>
          </Accordion>
        )}
        {!isProcurementReport && (
          <>
            <Accordion expanded={expanded === 'panel17'} onChange={handleChange('panel17')}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel17-content"
                id="panel17-header"
              >
                <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                  <Box display="flex" alignItems="center">
                    {(filters.find((a) => a.field === 'need_by_date')?.start && filters.find((a) => a.field === 'need_by_date')?.end) && (
                      <CheckIcon color="primary" />
                    )}
                    <Typography component="span">Need By Date</Typography>
                  </Box>
                  {expanded === 'panel17' && (
                    <Tooltip title="Remove Filter">
                      <CloseIcon
                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                        onClick={() => {
                          setFilters(filters.filter((a) => a.field !== 'need_by_date'));
                          setExpanded(false);
                        }}
                        fontSize="20"
                      />
                    </Tooltip>
                  )}
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <FormControl size="small" fullWidth variant="outlined">
                  <InputLabel htmlFor="standard-adornment-password" shrink={filters.find((a) => a.field === 'need_by_date')?.start === null || filters.find((a) => a.field === 'need_by_date')?.start === '' || filters.find((a) => a.field === 'need_by_date')?.start}>Date 1</InputLabel>
                  <OutlinedInput
                    label="Date 1"
                    id="Date 1"
                    type='date'
                    value={filters.find((a) => a.field === 'need_by_date')?.start || ''}
                    onChange={(e) => {
                      const arr = [...filters];
                      const index = arr.findIndex((a) => a.field === 'need_by_date');

                      if (index !== -1) {
                        // Update the existing object
                        arr[index] = {
                          ...arr[index],
                          start: moment(e.target.value).format('YYYY-MM-DD') || null,
                        };
                      } else {
                        // Add new object if not found
                        arr.push({
                          field: 'need_by_date',
                          op: 'range',
                          start: moment(e.target.value).format('YYYY-MM-DD') || null,
                        });
                      }
                      setFilters(arr);
                    }}
                  />
                </FormControl>
                <FormControl size="small" fullWidth variant="outlined" style={{ marginTop: 15 }}>
                  <InputLabel htmlFor="standard-adornment-password" shrink={filters.find((a) => a.field === 'need_by_date')?.end === null || filters.find((a) => a.field === 'need_by_date')?.end === '' || filters.find((a) => a.field === 'need_by_date')?.end}>Date 2</InputLabel>
                  <OutlinedInput
                    label="Date 2"
                    id="Date 2"
                    type='date'
                    value={filters.find((a) => a.field === 'need_by_date')?.end || ''}
                    onChange={(e) => {
                      const arr = [...filters];
                      const index = arr.findIndex((a) => a.field === 'need_by_date');

                      if (index !== -1) {
                        // Update the existing object
                        arr[index] = {
                          ...arr[index],
                          end: moment(e.target.value).format('YYYY-MM-DD') || null,
                        };
                      } else {
                        // Add new object if not found
                        arr.push({
                          field: 'need_by_date',
                          op: 'range',
                          end: moment(e.target.value).format('YYYY-MM-DD') || null,
                        });
                      }
                      setFilters(arr);
                    }}
                  />
                </FormControl>
              </AccordionDetails>
            </Accordion>
            <Accordion expanded={expanded === 'panel19'} onChange={handleChange('panel19')}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel19-content"
                id="panel19-header"
              >
                <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                  <Box display="flex" alignItems="center">
                    {filters.find((a) => a.field === 'price_type')?.values?.length > 0 && (
                      <CheckIcon color="primary" />
                    )}
                    <Typography component="span">Price Type</Typography>
                  </Box>
                  {expanded === 'panel19' && (
                    <Tooltip title="Remove Filter">
                      <CloseIcon
                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                        onClick={() => {
                          setFilters(filters.filter((a) => a.field !== 'price_type'));
                          setExpanded(false);
                        }}
                        fontSize="20"
                      />
                    </Tooltip>
                  )}
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Autocomplete
                  value={PriceType.filter((c) => filters.find((a) => a.field === 'price_type')?.values?.includes(c.value)) || []}
                  id="checkboxes-tags-demo"
                  size="small"
                  fullWidth
                  multiple
                  clearIcon={true}
                  disableCloseOnSelect
                  options={PriceType}
                  getOptionLabel={(option) => option?.name}
                  renderOption={(props, option, { selected }) => {
                    const { key, ...optionProps } = props;
                    return (
                      <li key={key} {...optionProps}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option.name}
                      </li>
                    );
                  }}
                  onChange={(event, newValue) => {
                    const arr = [...filters];
                    const index = arr.findIndex((a) => a.field === 'price_type');

                    if (index !== -1) {
                      // Update the existing object
                      arr[index] = {
                        ...arr[index],
                        values: newValue.map((a) => a.value),
                      };
                    } else {
                      // Add new object if not found
                      arr.push({
                        field: 'price_type',
                        op: 'in',
                        values: newValue.map((a) => a.value),
                      });
                    }
                    setFilters(arr);
                  }}
                  renderInput={(params) =>
                    <TextField
                      fullWidth
                      {...params}
                      label="Price Type"
                      name="Price Type"
                      variant="outlined"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />}
                />
              </AccordionDetails>
            </Accordion>
            <Accordion expanded={expanded === 'panel20'} onChange={handleChange('panel20')}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel20-content"
                id="panel20-header"
              >
                <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                  <Box display="flex" alignItems="center">
                    {filters.find((a) => a.field === 'division')?.values?.length > 0 && (
                      <CheckIcon color="primary" />
                    )}
                    <Typography component="span">Procurement</Typography>
                  </Box>
                  {expanded === 'panel20' && (
                    <Tooltip title="Remove Filter">
                      <CloseIcon
                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                        onClick={() => {
                          setFilters(filters.filter((a) => a.field !== 'division'));
                          setExpanded(false);
                        }}
                        fontSize="20"
                      />
                    </Tooltip>
                  )}
                </Box>
              </AccordionSummary>
            </Accordion>
            <Accordion expanded={expanded === 'panel11'} onChange={handleChange('panel11')}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel11-content"
                id="panel11-header"
              >
                <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                  <Box display="flex" alignItems="center">
                    {(filters.find((a) => a.field === 'furnish_responsibility')?.values?.length > 0 || filters.find((a) => a.field === 'install_responsibility')?.values?.length > 0) && (
                      <CheckIcon color="primary" />
                    )}
                    <Typography component="span">Responsibility</Typography>
                  </Box>
                  {expanded === 'panel11' && (
                    <Tooltip title="Remove Filter">
                      <CloseIcon
                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                        onClick={() => {
                          setFilters(filters.filter((a) => a.field !== 'furnish_responsibility' && a.field !== 'install_responsibility'));
                          setExpanded(false);
                        }}
                        fontSize="20"
                      />
                    </Tooltip>
                  )}
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Autocomplete
                  value={Responsibility.filter((c) => filters.find((a) => a.field === 'furnish_responsibility')?.values?.includes(c.value)) || []}
                  id="checkboxes-tags-demo"
                  size="small"
                  fullWidth
                  multiple
                  clearIcon={true}
                  disableCloseOnSelect
                  options={Responsibility}
                  getOptionLabel={(option) => option?.name}
                  renderOption={(props, option, { selected }) => {
                    const { key, ...optionProps } = props;
                    return (
                      <li key={key} {...optionProps}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option.name}
                      </li>
                    );
                  }}
                  onChange={(event, newValue) => {
                    const arr = [...filters];
                    const index = arr.findIndex((a) => a.field === 'furnish_responsibility');

                    if (index !== -1) {
                      // Update the existing object
                      arr[index] = {
                        ...arr[index],
                        values: newValue.map((a) => a.value),
                      };
                    } else {
                      // Add new object if not found
                      arr.push({
                        field: 'furnish_responsibility',
                        op: 'in',
                        values: newValue.map((a) => a.value),
                      });
                    }
                    setFilters(arr);
                  }}
                  renderInput={(params) =>
                    <TextField
                      fullWidth
                      {...params}
                      label="Furnish Responsibility"
                      name="Furnish Responsibility"
                      variant="outlined"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />}
                />
                <br />
                <Autocomplete
                  value={Responsibility.filter((c) => filters.find((a) => a.field === 'install_responsibility')?.values?.includes(c.value)) || []}
                  id="checkboxes-tags-demo"
                  size="small"
                  fullWidth
                  multiple
                  clearIcon={true}
                  disableCloseOnSelect
                  options={Responsibility}
                  getOptionLabel={(option) => option?.name}
                  renderOption={(props, option, { selected }) => {
                    const { key, ...optionProps } = props;
                    return (
                      <li key={key} {...optionProps}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option.name}
                      </li>
                    );
                  }}
                  onChange={(event, newValue) => {
                    const arr = [...filters];
                    const index = arr.findIndex((a) => a.field === 'install_responsibility');

                    if (index !== -1) {
                      // Update the existing object
                      arr[index] = {
                        ...arr[index],
                        values: newValue.map((a) => a.value),
                      };
                    } else {
                      // Add new object if not found
                      arr.push({
                        field: 'install_responsibility',
                        op: 'in',
                        values: newValue.map((a) => a.value),
                      });
                    }
                    setFilters(arr);
                  }}
                  renderInput={(params) =>
                    <TextField
                      fullWidth
                      {...params}
                      label="Install Responsibility"
                      name="Install Responsibility"
                      variant="outlined"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />}
                />
              </AccordionDetails>
            </Accordion>
            <Accordion expanded={expanded === 'panel21'} onChange={handleChange('panel21')}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel21-content"
                id="panel21-header"
              >
                <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                  <Box display="flex" alignItems="center">
                    {filters.find((a) => a.field === 'room_id')?.values?.length > 0 && (
                      <CheckIcon color="primary" />
                    )}
                    <Typography component="span">Room</Typography>
                  </Box>
                  {expanded === 'panel21' && (
                    <Tooltip title="Remove Filter">
                      <CloseIcon
                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                        onClick={() => {
                          setFilters(filters.filter((a) => a.field !== 'room_id'));
                          setExpanded(false);
                        }}
                        fontSize="20"
                      />
                    </Tooltip>
                  )}
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Autocomplete
                  value={roomData.filter((c) => filters.find((a) => a.field === 'room_id')?.values?.includes(c.room_id)) || []}
                  id="checkboxes-tags-demo"
                  size="small"
                  fullWidth
                  multiple
                  clearIcon={true}
                  disableCloseOnSelect
                  options={roomData}
                  getOptionLabel={(option) => `${option?.room_name} ${option.room_no ? `(${option.room_no})` : ''}`}
                  renderOption={(props, option, { selected }) => {
                    const { key, ...optionProps } = props;
                    return (
                      <li key={key} {...optionProps}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {`${option?.room_name} ${option.room_no ? `(${option.room_no})` : ''}`}
                      </li>
                    );
                  }}
                  onChange={(event, newValue) => {
                    const arr = [...filters];
                    const index = arr.findIndex((a) => a.field === 'room_id');

                    if (index !== -1) {
                      // Update the existing object
                      arr[index] = {
                        ...arr[index],
                        values: newValue.map((a) => a.room_id),
                      };
                    } else {
                      // Add new object if not found
                      arr.push({
                        field: 'room_id',
                        op: 'in',
                        values: newValue.map((a) => a.room_id),
                      });
                    }
                    setFilters(arr);
                  }}
                  renderInput={(params) =>
                    <TextField
                      fullWidth
                      {...params}
                      label="Room"
                      name="Room"
                      variant="outlined"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />}
                />
              </AccordionDetails>
            </Accordion>
            <Accordion expanded={expanded === 'panel13'} onChange={handleChange('panel13')}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel13-content"
                id="panel13-header"
              >
                <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                  <Box display="flex" alignItems="center">
                    {filters.find((a) => a.field === 'stage')?.values?.length > 0 && (
                      <CheckIcon color="primary" />
                    )}
                    <Typography component="span">Stage</Typography>
                  </Box>
                  {expanded === 'panel13' && (
                    <Tooltip title="Remove Filter">
                      <CloseIcon
                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                        onClick={() => {
                          setFilters(filters.filter((a) => a.field !== 'stage'));
                          setExpanded(false);
                        }}
                        fontSize="20"
                      />
                    </Tooltip>
                  )}
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Autocomplete
                  value={ActionStage.filter((c) => filters.find((a) => a.field === 'stage')?.values?.includes(c.value)) || []}
                  id="checkboxes-tags-demo"
                  size="small"
                  fullWidth
                  multiple
                  clearIcon={true}
                  disableCloseOnSelect
                  options={ActionStage}
                  getOptionLabel={(option) => option?.name}
                  renderOption={(props, option, { selected }) => {
                    const { key, ...optionProps } = props;
                    return (
                      <li key={key} {...optionProps}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option.name}
                      </li>
                    );
                  }}
                  onChange={(event, newValue) => {
                    const arr = [...filters];
                    const index = arr.findIndex((a) => a.field === 'stage');

                    if (index !== -1) {
                      // Update the existing object
                      arr[index] = {
                        ...arr[index],
                        values: newValue.map((a) => a.value),
                      };
                    } else {
                      // Add new object if not found
                      arr.push({
                        field: 'stage',
                        op: 'in',
                        values: newValue.map((a) => a.value),
                      });
                    }
                    setFilters(arr);
                  }}
                  renderInput={(params) =>
                    <TextField
                      fullWidth
                      {...params}
                      label="Stage"
                      name="Stage"
                      variant="outlined"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />}
                />
              </AccordionDetails>
            </Accordion>
          </>)}
        {![ReportType[32], ReportType[36], ReportType[30]].includes(reportType) && (
          <Accordion expanded={expanded === 'panel14'} onChange={handleChange('panel14')}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel14-content"
              id="panel14-header"
            >
              <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                <Box display="flex" alignItems="center">
                  {filters.find((a) => a.field === 'status')?.values?.length > 0 && (
                    <CheckIcon color="primary" />
                  )}
                  <Typography component="span">Status</Typography>
                </Box>
                {expanded === 'panel14' && (
                  <Tooltip title="Remove Filter">
                    <CloseIcon
                      style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                      onClick={() => {
                        setFilters(filters.filter((a) => a.field !== 'status'));
                        setExpanded(false);
                      }}
                      fontSize="20"
                    />
                  </Tooltip>
                )}
              </Box>
            </AccordionSummary>
            <AccordionDetails>
              <Autocomplete
                value={(!isProcurementReport ? ItemStatus : PAStatus).filter((c) => filters.find((a) => a.field === 'status')?.values?.includes(c.value)) || []}
                id="checkboxes-tags-demo"
                size="small"
                fullWidth
                multiple
                clearIcon={true}
                disableCloseOnSelect
                options={!isProcurementReport ? ItemStatus : PAStatus}
                getOptionLabel={(option) => option?.name}
                renderOption={(props, option, { selected }) => {
                  const { key, ...optionProps } = props;
                  return (
                    <li key={key} {...optionProps}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option.name}
                    </li>
                  );
                }}
                onChange={(event, newValue) => {
                  const arr = [...filters];
                  const index = arr.findIndex((a) => a.field === 'status');

                  if (index !== -1) {
                    // Update the existing object
                    arr[index] = {
                      ...arr[index],
                      values: newValue.map((a) => a.value),
                    };
                  } else {
                    // Add new object if not found
                    arr.push({
                      field: 'status',
                      op: 'in',
                      values: newValue.map((a) => a.value),
                    });
                  }
                  setFilters(arr);
                }}
                renderInput={(params) =>
                  <TextField
                    fullWidth
                    {...params}
                    label="Status"
                    name="Status"
                    variant="outlined"
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />}
              />
            </AccordionDetails>
          </Accordion>)}
        {!isProcurementReport && (
          <Accordion expanded={expanded === 'panel15'} onChange={handleChange('panel15')}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel15-content"
              id="panel15-header"
            >
              <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                <Box display="flex" alignItems="center">
                  {filters.find((a) => a.field === 'type')?.values?.length > 0 && (
                    <CheckIcon color="primary" />
                  )}
                  <Typography component="span">Type</Typography>
                </Box>
                {expanded === 'panel15' && (
                  <Tooltip title="Remove Filter">
                    <CloseIcon
                      style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                      onClick={() => {
                        setFilters(filters.filter((a) => a.field !== 'type'));
                        setExpanded(false);
                      }}
                      fontSize="20"
                    />
                  </Tooltip>
                )}
              </Box>
            </AccordionSummary>
            <AccordionDetails>
              <Autocomplete
                value={ProductType.filter((c) => filters.find((a) => a.field === 'type')?.values?.includes(c.value)) || []}
                id="checkboxes-tags-demo"
                size="small"
                fullWidth
                multiple
                clearIcon={true}
                disableCloseOnSelect
                options={ProductType}
                getOptionLabel={(option) => option?.name}
                renderOption={(props, option, { selected }) => {
                  const { key, ...optionProps } = props;
                  return (
                    <li key={key} {...optionProps}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option.name}
                    </li>
                  );
                }}
                onChange={(event, newValue) => {
                  const arr = [...filters];
                  const index = arr.findIndex((a) => a.field === 'type');

                  if (index !== -1) {
                    // Update the existing object
                    arr[index] = {
                      ...arr[index],
                      values: newValue.map((a) => a.value),
                    };
                  } else {
                    arr.push({
                      field: 'type',
                      op: 'in',
                      values: newValue.map((a) => a.value),
                    });
                  }
                  setFilters(arr);
                }}
                renderInput={(params) =>
                  <TextField
                    fullWidth
                    {...params}
                    label="Type"
                    name="Type"
                    variant="outlined"
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />}
              />
            </AccordionDetails>
          </Accordion>)}
        <Accordion expanded={expanded === 'panel16'} onChange={handleChange('panel16')}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel16-content"
            id="panel16-header"
          >
            <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
              <Box display="flex" alignItems="center">
                {filters.find((a) => a.field === 'vendor_id')?.values?.length > 0 && (
                  <CheckIcon color="primary" />
                )}
                <Typography component="span">Vendors</Typography>
              </Box>
              {expanded === 'panel16' && (
                <Tooltip title="Remove Filter">
                  <CloseIcon
                    style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                    onClick={() => {
                      setFilters(filters.filter((a) => a.field !== 'vendor_id'));
                      setExpanded(false);
                    }}
                    fontSize="20"
                  />
                </Tooltip>
              )}
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            <Autocomplete
              value={vendorData.filter((c) => filters.find((a) => a.field === 'vendor_id')?.values?.includes(c.product_provider_id)) || []}
              id="checkboxes-tags-demo"
              size="small"
              fullWidth
              multiple
              clearIcon={true}
              disableCloseOnSelect
              options={vendorData}
              getOptionLabel={(option) => option?.name}
              renderOption={(props, option, { selected }) => {
                const { key, ...optionProps } = props;
                return (
                  <li key={key} {...optionProps}>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                    />
                    {option.name}
                  </li>
                );
              }}
              onChange={(event, newValue) => {
                const arr = [...filters];
                const index = arr.findIndex((a) => a.field === 'vendor_id');

                if (index !== -1) {
                  // Update the existing object
                  arr[index] = {
                    ...arr[index],
                    values: newValue.map((a) => a.product_provider_id),
                  };
                } else {
                  // Add new object if not found
                  arr.push({
                    field: 'vendor_id',
                    op: 'in',
                    values: newValue.map((a) => a.product_provider_id),
                  });
                }
                setFilters(arr);
              }}
              inputValue={inputValue === 0 || inputValue === 'on' ? '' : inputValue}
              onInputChange={(e) => {
                if (e) {
                  setInputValue(e.target.value);
                  if (e?.target?.value?.length >= 1) {
                    getVendorData(e?.target?.value);
                  }
                }
              }}
              renderInput={(params) =>
                <TextField
                  fullWidth
                  {...params}
                  label="Vendor"
                  name="Vendor"
                  variant="outlined"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {vendorLoading ? <CircularProgress color="primary" size={20} /> : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />}
            />
          </AccordionDetails>
        </Accordion>
        {((isProcurementReport && reportType !== ReportType[30]) || reportType === ReportType[40]) && (
          <>
            {isProcurementReport && (
              <Accordion expanded={expanded === 'panel22'} onChange={handleChange('panel22')}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel22-content"
                  id="panel22-header"
                >
                  <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                    <Box display="flex" alignItems="center">
                      {filters.find((a) => a.field === 'action_id')?.values?.length > 0 && (
                        <CheckIcon color="primary" />
                      )}
                      <Typography component="span">{[ReportType[31], ReportType[35]].includes(reportType) ? "Requisition ID" : [ReportType[32], ReportType[36]].includes(reportType) ? 'Bid ID' : [ReportType[33], ReportType[37]].includes(reportType) ? 'RFQ ID' : 'PO ID'}</Typography>
                    </Box>
                    {expanded === 'panel22' && (
                      <Tooltip title="Remove Filter">
                        <CloseIcon
                          style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                          onClick={() => {
                            setFilters(filters.filter((a) => a.field !== 'action_id'));
                            setExpanded(false);
                          }}
                          fontSize="20"
                        />
                      </Tooltip>
                    )}
                  </Box>
                </AccordionSummary>
                <AccordionDetails>
                  <Autocomplete
                    value={actionData.filter((c) => filters.find((a) => a.field === 'action_id')?.values?.includes(c.action_id)) || []}
                    id="checkboxes-tags-demo"
                    size="small"
                    fullWidth
                    multiple
                    clearIcon={true}
                    disableCloseOnSelect
                    options={actionData}
                    getOptionLabel={(option) => option?.action_id}
                    renderOption={(props, option, { selected }) => {
                      const { key, ...optionProps } = props;
                      return (
                        <li key={key} {...optionProps}>
                          <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{ marginRight: 8 }}
                            checked={selected}
                          />
                          {option.action_id}
                        </li>
                      );
                    }}
                    onChange={(event, newValue) => {
                      const arr = [...filters];
                      const index = arr.findIndex((a) => a.field === 'action_id');

                      if (index !== -1) {
                        // Update the existing object
                        arr[index] = {
                          ...arr[index],
                          values: newValue.map((a) => a.action_id),
                        };
                      } else {
                        // Add new object if not found
                        arr.push({
                          field: 'action_id',
                          op: 'in',
                          values: newValue.map((a) => a.action_id),
                        });
                      }
                      setFilters(arr);
                    }}
                    renderInput={(params) =>
                      <TextField
                        fullWidth
                        {...params}
                        label={[ReportType[31], ReportType[35]].includes(reportType) ? "Requisition ID" : [ReportType[32], ReportType[36]].includes(reportType) ? 'Bid ID' : [ReportType[33], ReportType[37]].includes(reportType) ? 'RFQ ID' : 'PO ID'}
                        name={[ReportType[31], ReportType[35]].includes(reportType) ? "Requisition ID" : [ReportType[32], ReportType[36]].includes(reportType) ? 'Bid ID' : [ReportType[33], ReportType[37]].includes(reportType) ? 'RFQ ID' : 'PO ID'}
                        variant="outlined"
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                      />}
                  />
                </AccordionDetails>
              </Accordion>
            )}
            <Accordion expanded={expanded === 'panel23'} onChange={handleChange('panel23')}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel23-content"
                id="panel23-header"
              >
                <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                  <Box display="flex" alignItems="center">
                    {filters.find((a) => a.field === 'action_no')?.values?.length > 0 && (
                      <CheckIcon color="primary" />
                    )}
                    <Typography component="span">{[ReportType[31], ReportType[35]].includes(reportType) ? "Requisition No" : [ReportType[32], ReportType[36]].includes(reportType) ? 'Bid No' : [ReportType[33], ReportType[37]].includes(reportType) ? 'RFQ No' : 'PO No'}</Typography>
                  </Box>
                  {expanded === 'panel23' && (
                    <Tooltip title="Remove Filter">
                      <CloseIcon
                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                        onClick={() => {
                          setFilters(filters.filter((a) => a.field !== 'action_no'));
                          setExpanded(false);
                        }}
                        fontSize="20"
                      />
                    </Tooltip>
                  )}
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Autocomplete
                  value={actionData.filter((c) => filters.find((a) => a.field === 'action_no')?.values?.includes(c.action_no)) || []}
                  id="checkboxes-tags-demo"
                  size="small"
                  fullWidth
                  multiple
                  clearIcon={true}
                  disableCloseOnSelect
                  options={actionData}
                  getOptionLabel={(option) => option?.action_no}
                  renderOption={(props, option, { selected }) => {
                    const { key, ...optionProps } = props;
                    return (
                      <li key={key} {...optionProps}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option.action_no}
                      </li>
                    );
                  }}
                  onChange={(event, newValue) => {
                    const arr = [...filters];
                    const index = arr.findIndex((a) => a.field === 'action_no');

                    if (index !== -1) {
                      // Update the existing object
                      arr[index] = {
                        ...arr[index],
                        values: newValue.map((a) => a.action_no),
                      };
                    } else {
                      // Add new object if not found
                      arr.push({
                        field: 'action_no',
                        op: 'in',
                        values: newValue.map((a) => a.action_no),
                      });
                    }
                    setFilters(arr);
                  }}
                  renderInput={(params) =>
                    <TextField
                      fullWidth
                      {...params}
                      label={[ReportType[31], ReportType[35]].includes(reportType) ? "Requisition No" : [ReportType[32], ReportType[36]].includes(reportType) ? 'Bid No' : [ReportType[33], ReportType[37]].includes(reportType) ? 'RFQ No' : 'PO No'}
                      name={[ReportType[31], ReportType[35]].includes(reportType) ? "Requisition No" : [ReportType[32], ReportType[36]].includes(reportType) ? 'Bid No' : [ReportType[33], ReportType[37]].includes(reportType) ? 'RFQ No' : 'PO No'}
                      variant="outlined"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />}
                />
              </AccordionDetails>
            </Accordion>
            {![ReportType[32], ReportType[36], ReportType[40]].includes(reportType) && (
              <Accordion expanded={expanded === 'panel24'} onChange={handleChange('panel24')}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel24-content"
                  id="panel24-header"
                >
                  <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                    <Box display="flex" alignItems="center">
                      {filters?.is_quote && (
                        <CheckIcon color="primary" />
                      )}
                      <Typography component="span">Quote</Typography>
                    </Box>
                    {expanded === 'panel24' && (
                      <Tooltip title="Remove Filter">
                        <CloseIcon
                          style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                          onClick={() => {
                            setFilters(filters.filter((a) => a.field !== 'is_quote'));
                            setExpanded(false);
                          }}
                          fontSize="20"
                        />
                      </Tooltip>
                    )}
                  </Box>
                </AccordionSummary>
                <AccordionDetails>
                  <Box style={{ display: 'flex', gap: 5 }}>
                    <FixedButton
                      variant={filters?.find((a) => a.field === 'is_quote')?.values === 'yes' ? 'contained' : 'outlined'}
                      onClick={() => {
                        const arr = [...filters];
                        const index = arr.findIndex((a) => a.field === 'is_quote');

                        if (index !== -1) {
                          // Update the existing object
                          arr[index] = {
                            ...arr[index],
                            values: 'yes',
                          };
                        } else {
                          // Add new object if not found
                          arr.push({
                            field: 'is_quote',
                            op: 'equal',
                            values: 'yes',
                          });
                        }
                        setFilters(arr);
                      }}
                    >
                      Yes
                    </FixedButton>
                    <FixedButton
                      variant={filters?.find((a) => a.field === 'is_quote')?.values === 'no' ? 'contained' : 'outlined'}
                      onClick={() => {
                        const arr = [...filters];
                        const index = arr.findIndex((a) => a.field === 'is_quote');

                        if (index !== -1) {
                          // Update the existing object
                          arr[index] = {
                            ...arr[index],
                            values: 'no',
                          };
                        } else {
                          // Add new object if not found
                          arr.push({
                            field: 'is_quote',
                            op: 'equal',
                            values: 'no',
                          });
                        }
                        setFilters(arr);
                      }}
                    >
                      No
                    </FixedButton>
                  </Box>
                </AccordionDetails>
              </Accordion>
            )}
            {[ReportType[32], ReportType[36]].includes(reportType) && (
              <Accordion expanded={expanded === 'panel25'} onChange={handleChange('panel25')}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel25-content"
                  id="panel25-header"
                >
                  <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                    <Box display="flex" alignItems="center">
                      {filters.find((a) => a.field === 'bid_group_id')?.values?.length > 0 && (
                        <CheckIcon color="primary" />
                      )}
                      <Typography component="span">Bid Group</Typography>
                    </Box>
                    {expanded === 'panel25' && (
                      <Tooltip title="Remove Filter">
                        <CloseIcon
                          style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                          onClick={() => {
                            setFilters(filters.filter((a) => a.field !== 'bid_group_id'));
                            setExpanded(false);
                          }}
                          fontSize="20"
                        />
                      </Tooltip>
                    )}
                  </Box>
                </AccordionSummary>
                <AccordionDetails>
                  <Autocomplete
                    value={bidGroupData.filter((c) => filters.find((a) => a.field === 'bid_group_id')?.values?.includes(c.bid_group_id)) || []}
                    id="checkboxes-tags-demo"
                    size="small"
                    fullWidth
                    multiple
                    clearIcon={true}
                    disableCloseOnSelect
                    options={bidGroupData}
                    getOptionLabel={(option) => option?.name}
                    renderOption={(props, option, { selected }) => {
                      const { key, ...optionProps } = props;
                      return (
                        <li key={key} {...optionProps}>
                          <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{ marginRight: 8 }}
                            checked={selected}
                          />
                          {option.name}
                        </li>
                      );
                    }}
                    onChange={(event, newValue) => {
                      const arr = [...filters];
                      const index = arr.findIndex((a) => a.field === 'bid_group_id');

                      if (index !== -1) {
                        // Update the existing object
                        arr[index] = {
                          ...arr[index],
                          values: newValue.map((a) => a.bid_group_id),
                        };
                      } else {
                        // Add new object if not found
                        arr.push({
                          field: 'bid_group_id',
                          op: 'in',
                          values: newValue.map((a) => a.bid_group_id),
                        });
                      }
                      setFilters(arr);
                    }}
                    renderInput={(params) =>
                      <TextField
                        fullWidth
                        {...params}
                        label="Bid Group"
                        name="Bid Group"
                        variant="outlined"
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {bidGroupLoading ? <CircularProgress color="primary" size={20} /> : null}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                      />}
                  />
                </AccordionDetails>
              </Accordion>
            )}
          </>
        )}
        {reportType === ReportType[30] && (
          <>
            <Accordion expanded={expanded === 'panel27'} onChange={handleChange('panel27')}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel27-content"
                id="panel27-header"
              >
                <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                  <Box display="flex" alignItems="center">
                    {filters.find((a) => a.field === 'pa_id')?.values?.length > 0 && (
                      <CheckIcon color="primary" />
                    )}
                    <Typography component="span">PA ID</Typography>
                  </Box>
                  {expanded === 'panel27' && (
                    <Tooltip title="Remove Filter">
                      <CloseIcon
                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                        onClick={() => {
                          setFilters(filters.filter((a) => a.field !== 'pa_id'));
                          setExpanded(false);
                        }}
                        fontSize="20"
                      />
                    </Tooltip>
                  )}
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Autocomplete
                  value={(requisitionData || biddingData || rfqData || poData).filter((c) => filters.find((a) => a.field === 'pa_id')?.values?.includes(c.pa_id)) || []}
                  id="checkboxes-tags-demo"
                  size="small"
                  fullWidth
                  multiple
                  clearIcon={true}
                  disableCloseOnSelect
                  options={(requisitionData || biddingData || rfqData || poData)}
                  getOptionLabel={(option) => option?.pa_id}
                  renderOption={(props, option, { selected }) => {
                    const { key, ...optionProps } = props;
                    return (
                      <li key={key} {...optionProps}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option.pa_id}
                      </li>
                    );
                  }}
                  onChange={(event, newValue) => {
                    const arr = [...filters];
                    const index = arr.findIndex((a) => a.field === 'pa_id');

                    if (index !== -1) {
                      // Update the existing object
                      arr[index] = {
                        ...arr[index],
                        values: newValue.map((a) => a.pa_id),
                      };
                    } else {
                      // Add new object if not found
                      arr.push({
                        field: 'pa_id',
                        op: 'in',
                        values: newValue.map((a) => a.pa_id),
                      });
                    }
                    setFilters(arr);
                  }}
                  renderInput={(params) =>
                    <TextField
                      fullWidth
                      {...params}
                      label="PA ID"
                      name="PA ID"
                      variant="outlined"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />}
                />
              </AccordionDetails>
            </Accordion>
            <Accordion expanded={expanded === 'panel28'} onChange={handleChange('panel28')}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel28-content"
                id="panel28-header"
              >
                <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                  <Box display="flex" alignItems="center">
                    {filters.find((a) => a.field === 'requisition_no')?.values?.length > 0 && (
                      <CheckIcon color="primary" />
                    )}
                    <Typography component="span">Requisition #</Typography>
                  </Box>
                  {expanded === 'panel28' && (
                    <Tooltip title="Remove Filter">
                      <CloseIcon
                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                        onClick={() => {
                          setFilters(filters.filter((a) => a.field !== 'requisition_no'));
                          setExpanded(false);
                        }}
                        fontSize="20"
                      />
                    </Tooltip>
                  )}
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Autocomplete
                  value={requisitionData.filter((c) => filters.find((a) => a.field === 'requisition_no')?.values?.includes(c.action_no)) || []}
                  id="checkboxes-tags-demo"
                  size="small"
                  fullWidth
                  multiple
                  clearIcon={true}
                  disableCloseOnSelect
                  options={requisitionData}
                  getOptionLabel={(option) => option?.action_no}
                  renderOption={(props, option, { selected }) => {
                    const { key, ...optionProps } = props;
                    return (
                      <li key={key} {...optionProps}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option.action_no}
                      </li>
                    );
                  }}
                  onChange={(event, newValue) => {
                    const arr = [...filters];
                    const index = arr.findIndex((a) => a.field === 'requisition_no');

                    if (index !== -1) {
                      // Update the existing object
                      arr[index] = {
                        ...arr[index],
                        values: newValue.map((a) => a.action_no),
                      };
                    } else {
                      // Add new object if not found
                      arr.push({
                        field: 'requisition_no',
                        op: 'in',
                        values: newValue.map((a) => a.action_no),
                      });
                    }
                    setFilters(arr);
                  }}
                  renderInput={(params) =>
                    <TextField
                      fullWidth
                      {...params}
                      label="Requisition #"
                      name="Requisition #"
                      variant="outlined"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />}
                />
              </AccordionDetails>
            </Accordion>
            <Accordion expanded={expanded === 'panel29'} onChange={handleChange('panel29')}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel29-content"
                id="panel29-header"
              >
                <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                  <Box display="flex" alignItems="center">
                    {filters.find((a) => a.field === 'bid_no')?.values?.length > 0 && (
                      <CheckIcon color="primary" />
                    )}
                    <Typography component="span">Bid #</Typography>
                  </Box>
                  {expanded === 'panel29' && (
                    <Tooltip title="Remove Filter">
                      <CloseIcon
                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                        onClick={() => {
                          setFilters(filters.filter((a) => a.field !== 'bid_no'));
                          setExpanded(false);
                        }}
                        fontSize="20"
                      />
                    </Tooltip>
                  )}
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Autocomplete
                  value={biddingData.filter((c) => filters.find((a) => a.field === 'bid_no')?.values?.includes(c.action_no)) || []}
                  id="checkboxes-tags-demo"
                  size="small"
                  fullWidth
                  multiple
                  clearIcon={true}
                  disableCloseOnSelect
                  options={biddingData}
                  getOptionLabel={(option) => option?.action_no}
                  renderOption={(props, option, { selected }) => {
                    const { key, ...optionProps } = props;
                    return (
                      <li key={key} {...optionProps}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option.action_no}
                      </li>
                    );
                  }}
                  onChange={(event, newValue) => {
                    const arr = [...filters];
                    const index = arr.findIndex((a) => a.field === 'bid_no');

                    if (index !== -1) {
                      // Update the existing object
                      arr[index] = {
                        ...arr[index],
                        values: newValue.map((a) => a.action_no),
                      };
                    } else {
                      // Add new object if not found
                      arr.push({
                        field: 'bid_no',
                        op: 'in',
                        values: newValue.map((a) => a.action_no),
                      });
                    }
                    setFilters(arr);
                  }}
                  renderInput={(params) =>
                    <TextField
                      fullWidth
                      {...params}
                      label="Bid #"
                      name="Bid #"
                      variant="outlined"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />}
                />
              </AccordionDetails>
            </Accordion>
            <Accordion expanded={expanded === 'panel30'} onChange={handleChange('panel30')}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel30-content"
                id="panel30-header"
              >
                <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                  <Box display="flex" alignItems="center">
                    {filters.find((a) => a.field === 'rfq_no')?.values?.length > 0 && (
                      <CheckIcon color="primary" />
                    )}
                    <Typography component="span">RFQ #</Typography>
                  </Box>
                  {expanded === 'panel30' && (
                    <Tooltip title="Remove Filter">
                      <CloseIcon
                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                        onClick={() => {
                          setFilters(filters.filter((a) => a.field !== 'rfq_no'));
                          setExpanded(false);
                        }}
                        fontSize="20"
                      />
                    </Tooltip>
                  )}
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Autocomplete
                  value={rfqData.filter((c) => filters.find((a) => a.field === 'rfq_no')?.values?.includes(c.action_no)) || []}
                  id="checkboxes-tags-demo"
                  size="small"
                  fullWidth
                  multiple
                  clearIcon={true}
                  disableCloseOnSelect
                  options={rfqData}
                  getOptionLabel={(option) => option?.action_no}
                  renderOption={(props, option, { selected }) => {
                    const { key, ...optionProps } = props;
                    return (
                      <li key={key} {...optionProps}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option.action_no}
                      </li>
                    );
                  }}
                  onChange={(event, newValue) => {
                    const arr = [...filters];
                    const index = arr.findIndex((a) => a.field === 'rfq_no');

                    if (index !== -1) {
                      // Update the existing object
                      arr[index] = {
                        ...arr[index],
                        values: newValue.map((a) => a.action_no),
                      };
                    } else {
                      // Add new object if not found
                      arr.push({
                        field: 'rfq_no',
                        op: 'in',
                        values: newValue.map((a) => a.action_no),
                      });
                    }
                    setFilters(arr);
                  }}
                  renderInput={(params) =>
                    <TextField
                      fullWidth
                      {...params}
                      label="RFQ #"
                      name="RFQ #"
                      variant="outlined"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />}
                />
              </AccordionDetails>
            </Accordion>
            <Accordion expanded={expanded === 'panel31'} onChange={handleChange('panel31')}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel31-content"
                id="panel31-header"
              >
                <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                  <Box display="flex" alignItems="center">
                    {filters.find((a) => a.field === 'po_no')?.values?.length > 0 && (
                      <CheckIcon color="primary" />
                    )}
                    <Typography component="span">PO #</Typography>
                  </Box>
                  {expanded === 'panel31' && (
                    <Tooltip title="Remove Filter">
                      <CloseIcon
                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                        onClick={() => {
                          setFilters(filters.filter((a) => a.field !== 'po_no'));
                          setExpanded(false);
                        }}
                        fontSize="20"
                      />
                    </Tooltip>
                  )}
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Autocomplete
                  value={poData.filter((c) => filters.find((a) => a.field === 'po_no')?.values?.includes(c.action_no)) || []}
                  id="checkboxes-tags-demo"
                  size="small"
                  fullWidth
                  multiple
                  clearIcon={true}
                  disableCloseOnSelect
                  options={poData}
                  getOptionLabel={(option) => option?.action_no}
                  renderOption={(props, option, { selected }) => {
                    const { key, ...optionProps } = props;
                    return (
                      <li key={key} {...optionProps}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option.action_no}
                      </li>
                    );
                  }}
                  onChange={(event, newValue) => {
                    const arr = [...filters];
                    const index = arr.findIndex((a) => a.field === 'po_no');

                    if (index !== -1) {
                      // Update the existing object
                      arr[index] = {
                        ...arr[index],
                        values: newValue.map((a) => a.action_no),
                      };
                    } else {
                      // Add new object if not found
                      arr.push({
                        field: 'po_no',
                        op: 'in',
                        values: newValue.map((a) => a.action_no),
                      });
                    }
                    setFilters(arr);
                  }}
                  renderInput={(params) =>
                    <TextField
                      fullWidth
                      {...params}
                      label="PO #"
                      name="PO #"
                      variant="outlined"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />}
                />
              </AccordionDetails>
            </Accordion>
          </>
        )}
      </FilterContent>
      <FilterFooter>
        <FixedButton variant="outlined" color="secondary" onClick={() => {
          applyFilter([]);
          setFilters([]);
          setExpanded(false);
        }}>Clear</FixedButton>
        <FixedButton variant="outlined" color="primary" onClick={() => handleFilter()}>Save</FixedButton>
      </FilterFooter>
    </CustomFilterPanelWrapper>
  )
}